import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { RestaurantsContext, IRestaurantsContext } from '../../restaurantsState/restaurantsContext';
import { EntityStatus } from 'types';
import { ActiveRestaurantsList } from './components/ActiveRestaurantsList/ActiveRestaurantsList';
import { ArchivedRestaurantsList } from './components/ArchivedRestaurantsList/ArchivedRestaurantsList';
import { DeletedRestaurantsList } from './components/DeletedRestaurantsList/DeletedRestaurantsList';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Restaurants.module.scss';

const Restaurants: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, restaurants, currentPage, countOfItems, status } =
		useContext<IRestaurantsContext>(RestaurantsContext);

	return (
		<>
			{restaurants.restaurantCount ? (
				<div className={style.container} data-test="Restaurants">
					{status === EntityStatus.Active && <ActiveRestaurantsList />}
					{status === EntityStatus.Archived && <ArchivedRestaurantsList />}
					{status === EntityStatus.Deleted && <DeletedRestaurantsList />}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={restaurants.restaurantCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Restaurants;
